import { useEffect, useState } from "react";

function fmtEUR(n: number) {
  return n.toLocaleString("es-ES", { style: "currency", currency: "EUR" });
}
function pct(a: number, b: number) {
  if (!b) return 0;
  return Math.round(((a - b) / b) * 100);
}

export default function EffectiveValueBadge({
  base,
  multiplier,
  align = "right"
}: {
  base: number;
  multiplier: number;
  align?: "left" | "right";
}) {
  const effective = Math.max(0, base * (multiplier || 1));
  const deltaPct = pct(effective, base);
  const up = deltaPct >= 0;

  const [show, setShow] = useState(false);
  useEffect(() => {
    setShow(Boolean(base && Math.abs(multiplier - 1) > 0.001));
  }, [base, multiplier]);

  if (!show) return null;

  return (
    <div
      className={`eff-badge ${up ? "up" : "down"} ${align === "left" ? "left" : "right"}`}
      aria-label={`Valor simulado ${fmtEUR(effective)} (${deltaPct >= 0 ? "+" : ""}${deltaPct}%)`}
      title={`Valor simulado ${fmtEUR(effective)} (${deltaPct >= 0 ? "+" : ""}${deltaPct}%)`}
    >
      <span className="arrow">{up ? "↑" : "↓"}</span>
      <span className="value">{fmtEUR(effective)}</span>
      <span className="delta">({deltaPct >= 0 ? "+" : ""}{deltaPct}%)</span>
    </div>
  );
}
